<template>
  <div
    id="teleport-toasts"
    class="fixed z-toast top-4 right-4 left-4 md:left-auto"
  />

  <DToast />
</template>
